/**
 * @flow
 * @relayHash fbb4e6a25269ecf3e63a22208ca95012
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type toggleHyeventEmailsInput = {|
  clientMutationId?: ?string,
  id: string,
  enableInviteEmail?: ?boolean,
  enableCancelEmail?: ?boolean,
  enableRescheduleEmail?: ?boolean,
  enableNightReminderEmail?: ?boolean,
  enableMorningReminderEmail?: ?boolean,
  enableFollowUpEmail?: ?boolean,
  enableRsvpedEmail?: ?boolean,
  enableRsvpCancelledEmail?: ?boolean,
  enableWaitlistedEmail?: ?boolean,
  enableWaitlistOpeningEmail?: ?boolean,
  enableThankYouEmail?: ?boolean,
|};
export type toggleEmailsMutationVariables = {|
  input: toggleHyeventEmailsInput
|};
export type toggleEmailsMutationResponse = {|
  +toggleHyeventEmails: ?{|
    +hyevent: ?{|
      +id: string,
      +thankYouCampaignId: string,
      +enableThankYouEmail: ?boolean,
      +enableCancelEmail: ?boolean,
      +enableFollowUpEmail: ?boolean,
      +enableInviteEmail: ?boolean,
      +enableMorningReminderEmail: ?boolean,
      +enableNightReminderEmail: ?boolean,
      +enableRescheduleEmail: ?boolean,
      +enableRsvpCancelledEmail: ?boolean,
      +enableRsvpedEmail: ?boolean,
      +enableWaitlistOpeningEmail: ?boolean,
      +enableWaitlistedEmail: ?boolean,
    |}
  |}
|};
export type toggleEmailsMutation = {|
  variables: toggleEmailsMutationVariables,
  response: toggleEmailsMutationResponse,
|};
*/


/*
mutation toggleEmailsMutation(
  $input: toggleHyeventEmailsInput!
) {
  toggleHyeventEmails(input: $input) {
    hyevent {
      id
      thankYouCampaignId
      enableThankYouEmail
      enableCancelEmail
      enableFollowUpEmail
      enableInviteEmail
      enableMorningReminderEmail
      enableNightReminderEmail
      enableRescheduleEmail
      enableRsvpCancelledEmail
      enableRsvpedEmail
      enableWaitlistOpeningEmail
      enableWaitlistedEmail
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "toggleHyeventEmailsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "toggleHyeventEmails",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "toggleHyeventEmailsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thankYouCampaignId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableThankYouEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableCancelEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableFollowUpEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableInviteEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableMorningReminderEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableNightReminderEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableRescheduleEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableRsvpCancelledEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableRsvpedEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableWaitlistOpeningEmail",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enableWaitlistedEmail",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "toggleEmailsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "toggleEmailsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "toggleEmailsMutation",
    "id": null,
    "text": "mutation toggleEmailsMutation(\n  $input: toggleHyeventEmailsInput!\n) {\n  toggleHyeventEmails(input: $input) {\n    hyevent {\n      id\n      thankYouCampaignId\n      enableThankYouEmail\n      enableCancelEmail\n      enableFollowUpEmail\n      enableInviteEmail\n      enableMorningReminderEmail\n      enableNightReminderEmail\n      enableRescheduleEmail\n      enableRsvpCancelledEmail\n      enableRsvpedEmail\n      enableWaitlistOpeningEmail\n      enableWaitlistedEmail\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '674593865284d59852270e4865877d9e';
module.exports = node;
